import PlanInfo from 'components/Common/PlanInfo';
import HeaderTitle from './HeaderTitle';

function CustomHeader() {
  return (
    <div className="common-header-hyp-info common-header-left-action">
      <HeaderTitle />
      <PlanInfo />
    </div>
  );
}

export default CustomHeader;
